export { default } from './StarGroup'
